$(document).ready(function () {
    downloadForm();
});

// Newsletter singup form
function downloadForm() {
    $('#download-form').on('submit', function (e) {
        e.preventDefault();

        let name = $('input[name="name"]', $(this)).val();
        let email = $('input[name="email"]', $(this)).val();
        let contactOptIn = $('input[name="contact_opt_in"]', $(this)).is(':checked') ? 1 : 0;
        let product = $('input[name="product"]', $(this)).val();

        let recaptchaResponse = grecaptcha.getResponse();

        $('.formElement').removeClass('error');
        $('#newsletter-form-header').find(".alert").remove();

        $.ajax({
            type: 'POST',
            url: 'ajax/download',
            data: {
                name: name,
                email: email,
                contact_opt_in: contactOptIn,
                product: product,
                'g-recaptcha-response': recaptchaResponse
            }
        }).done(function (feedback) {
            let alertClass;
            if (feedback.hasOwnProperty('error') && feedback.error === 1) {
                alertClass = 'danger';
            } else {
                $('#download-form').hide();
                alertClass = 'success';
            }
            const alertDiv = $('#download-header');
            alertDiv.append('<div class="alert mb-4 alert-' + alertClass + ' fade show" role="alert">' + feedback.message + '</div>');

            // If the response contains a file, add a download button
            if (feedback.hasOwnProperty('file')) {
                setTimeout(() => {

                    const downloadLink = document.createElement('a');
                    downloadLink.href = `${window.location.protocol}${feedback.file}`;
                    const filename = feedback.file.split('/').pop();
                    downloadLink.setAttribute('download', filename);
                    downloadLink.style.display = 'none';

                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    document.body.removeChild(downloadLink);

                    if (feedback.hasOwnProperty('message_failed') && feedback.hasOwnProperty('text_failed')) {
                        const downloadButton = document.createElement('a');
                        downloadButton.href = feedback.file;
                        downloadButton.textContent = feedback.text_failed;
                        downloadButton.setAttribute('download', filename)

                        const messageFailed = feedback.message_failed.replace(':link', downloadButton.outerHTML);

                        alertDiv.append(messageFailed);
                    }
                }, 2000);
            }
        });
    });
}
